export enum InvoiceStatusCode {
  Voucher = 'VOUCHER',
  VoucherLabeled = 'LABELLED',
  /** Printed or Emailed after labeled - can post */
  Printed = 'PRINTED',
  AwaitPost = 'AWAITPOST',
  InvoicePosted = 'POSTED',
  VoidError = 'VOIDERR'
}
